import { useEffect, useState } from 'react';
import { api } from '../../api';
import TileCard from '../components/TileCard';

/**
 * Dispatch Queue mini snapshot — 3 stat chips (open / claimed / avg
 * resolution). Click through goes to /queue.
 *
 * Used on the Driver dashboard (§3 per spec). Data source is the new
 * /api/dashboard/queue-stats endpoint — live queue aggregate (open +
 * claimed counts, trailing-7-day avg resolution minutes).
 *
 * Props:
 *   region      (optional) — filter to a region (future Phase 2)
 *   title       (optional) — override card title
 */
export default function DispatchQueueTile({ region, title = 'Dispatch Queue' }) {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    let cancelled = false;
    api.getDashboardQueueStats(region)
      .then(data => { if (!cancelled) setState({ loading: false, error: null, data }); })
      .catch(err => { if (!cancelled) setState({ loading: false, error: err?.message || 'failed', data: null }); });
    return () => { cancelled = true; };
  }, [region]);

  const d = state.data;

  return (
    <TileCard
      title={title}
      loading={state.loading}
      error={state.error}
      actionHref="/queue"
      actionLabel="View queue →"
    >
      <div className="dash-stat-row">
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">{d?.open ?? 0}</div>
          <div className="dash-stat-chip-label">Open</div>
        </div>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">{d?.claimed ?? 0}</div>
          <div className="dash-stat-chip-label">Claimed</div>
        </div>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">
            {d?.avg_resolution_minutes == null ? '—' : `${d.avg_resolution_minutes}m`}
          </div>
          <div className="dash-stat-chip-label">Team Avg · 7d</div>
        </div>
      </div>
      <div className="dash-card-empty" style={{ flex: 'initial', justifyContent: 'flex-start', padding: '8px 2px' }}>
        {d?.space_calls ?? 0} space calls in queue
      </div>
    </TileCard>
  );
}
